import { Divider, Flex, Popup } from "@evergis/ui";
import styled from "styled-components";

import { ToolsHintBlock } from "../../../../ToolsHint/ExamplesBlock";
import { AttributeSelector } from "../../../TableReferences/AttributeSelector";
import { ResultIcon } from "../../../TableReferences/styled";
import { ExtendedParameters } from "../../ExtendedParameters/ExtendedParameters";
import { Attributes } from "../Attributes";
import { AttributesActionsContainer, StickyShadowHide } from "../styled";

export const LayerAttributeSelector = styled(AttributeSelector)`
  margin-left: 0;
`;

export const TableReferencesInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 35rem;
  padding: 2rem;
  background-color: white;
  border-radius: ${({ theme: { borderRadius } }) => borderRadius.smallest};
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.15);
  box-sizing: border-box;
`;

export const Hints = styled(ToolsHintBlock)`
  margin: 0;
`;

export const InfoTitle = styled.div`
  font-size: 1rem;
  margin-bottom: 1rem;
`;

export const InfoSubTitle = styled.div`
  font-size: 0.75rem;
  margin-top: 1.5rem;
`;

export const InfoDescription = styled.div`
  font-size: 0.75rem;
  color: rgba(0, 0, 0, 0.54);
`;

export const EditPopup = styled(Popup)`
  max-width: 28.25rem;
`;

export const AttributeEditContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 28.25rem;
  padding: 1rem;
  background-color: ${({ theme: { palette } }) => palette.background};
  border-radius: ${({ theme: { borderRadius } }) => borderRadius.smallest};
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.15);
  box-sizing: border-box;
`;

export const AttributeEditSelector = styled(AttributeSelector)`
  margin-left: 0;
`;

export const EditResult = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

export const EditResultIcon = styled(ResultIcon)`
  transform: rotate(90deg);
  margin-top: 1rem;
  margin-bottom: 1rem;
`;

export const EditResultDivider = styled(Divider)`
  height: 1.5rem;
`;

export const AttributeEditActions = styled(Flex)`
  margin-top: 1rem;
  justify-content: center;
`;

export const AttributesExpander = styled(ExtendedParameters)`
  display: inline-flex;
  flex-direction: row-reverse;
  margin-bottom: 0;
  margin-top: 0;
`;

export const ReferencesAttributes = styled(Attributes)`
  margin-top: 0;
  
  ${AttributesActionsContainer} {
    background: none;
  }
  
  ${StickyShadowHide} {
    display: none;
  }
}
`;

export const HelpAction = styled.span`
  color: ${({ theme }) => theme.palette.primary};
  font-size: 10px;
  cursor: pointer;
  pointer-events: all !important;
`;
